// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__wrkA3","approved":"Status_approved__1fRjI","rejected":"Status_rejected__1IwfV","expired":"Status_expired__Pfj6L","label":"Status_label__HbLBe"};